var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.title ? _vm.title : _vm.routeTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }